import React from 'react';
import { DisplayButton } from '@xo-union/tk-ui-links';
import { EventType } from '../EventTypes';
import { EIPSection } from './EIPSection';
import { QuestionsComponent } from './EIPQuestionComponent';
import styles from './eipSection.scss';

interface Props {
  privateRsvp?: boolean;
  events?: EventType[];
  guestCount?: number;
  isRsvpRequired?: boolean;
  openEventModal?: (id: string) => void;
}

export const EventQuestions: React.FC<Props> = ({ events, openEventModal }) => {
  if (!events || events?.length < 1) {
    return null;
  }

  const sortedEvents = events.sort((x, y) => {
    // Sort WeddingDay to the top
    // eslint-disable-next-line no-nested-ternary
    return x.type === 'WeddingDay' ? -1 : y.type === 'WeddingDay' ? 1 : 0;
  });

  const openEvent = (eventId: string): void => {
    if (openEventModal) {
      openEventModal(eventId);
    } else {
      // eslint-disable-next-line no-console
      console.error('Please include the openEventModal prop for this version of RSVPSettings');
    }
  };

  const eventsComponent = sortedEvents.map(event => {
    const description = (
      <>
        <div>
          Add questions that all {event.guestCount || 0} guests on your{' '}
          <DisplayButton
            onClick={(): void => {
              openEvent(event.id);
            }}
            className={styles.displayLink}
          >
            {event.name}
          </DisplayButton>{' '}
          list will see when they RSVP &quot;Yes!&quot; on your Website.
        </div>
      </>
    );

    return (
      <div data-testid="event-questions">
        <EIPSection title={event.name} description={description}>
          <QuestionsComponent questions={event.questions} />
        </EIPSection>
      </div>
    );
  });

  return <>{eventsComponent}</>;
};
